//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MobileMenu from './MobileMenu'
import SelectCity from '~/components/header/SelectCity.vue'
import {UserMixin} from '~/node_modules/sitis-nuxt/lib/mixins'

export default {
  name: 'Header',

  components: {
    MobileMenu,
    SelectCity
  },
  emits: ['onSelectCity'],
  props: {
    menu: {
      type: Array,
      default() {
        return []
      }
    },
    categories: {
      type: Array,
      default() {
        return []
      }
    },
    appCfg: {
      type: Object
    },
    cityName: {
      type: String,
      default() {
        return this.appCfg?.city?.model?.name || 'Екатеринбург'
      }
    },
    appVars: {
      type: Object
    },
    itemsCount: {
      tupe: Number
    },
    wishlistCount: {
      tupe: Number
    },
    isLogoVisible: {
      type: Boolean,
      default() {
        return false
      }
    },
    additionalMenu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mixins: [UserMixin],

  data() {
    return {
      heightHeaderPlaceholder: 0,
      heightMenuPlaceholder: 0,
      isFixed: false,
      isOpenMenu: false,
      isHomePage: this.$router.history.current.fullPath === '/',
      eventCloseMenu: null,
      isOpenSearch: false,
      isOpenAuthorization: false,

      optionDialogAuthorization: {}
    }
  },
  computed: {
    getSubdomain() {
      const currHost = this.$store.getters['local-settings/currentHost']
      return `https://${currHost}`
    },

    menuHeader() {
      // количество линий в секции
      let rowColumn = 2
      if (this.$store.state['local-settings'].isJJ) {
        rowColumn = 1
      }

      const initMenu = [...this.menu]

      let key = 0
      const menu = []
      let column = []

      initMenu.map((item, idx) => {
        if (key >= rowColumn) {
          menu.push(column)
          column = []
          key = 0
        }

        column.push(item)
        key++
      })

      if (column.length > 0) {
        menu.push(column)
      }

      return menu
    },

    client() {
      return this.user || {}
    },

    isJJ: function () {
      return this.$store.state?.['local-settings']?.isJJ
    }
  },
  watch: {
    $route() {
      this.isHomePage = this.$router.history.current.fullPath === '/'

      this.onCloseMenu()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    const headerHeight = this.$refs.refHeader.clientHeight
    this.heightHeaderPlaceholder = `${headerHeight}px`
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll({target}) {
      const isFixed = Boolean((target?.scrollingElement?.scrollTop || 0) > 300)

      if (this.isFixed !== isFixed) {
        this.isFixed = isFixed
      }
    },

    onOpenMenu(newValue = null) {
      if (newValue !== null) {
        this.isOpenMenu = newValue

        setTimeout(() => {
          const menuHeight = this.$refs.refMenu.clientHeight
          this.heightMenuPlaceholder = `${menuHeight}px`
        }, 100)

        return null
      }

      clearTimeout(this.eventCloseMenu)
      this.isOpenMenu = true

      const isHomePage = Boolean(
        this.$route.path === '' || this.$route.path === '/'
      )

      if (!isHomePage) {
        return null
      }

      setTimeout(() => {
        const menuHeight = this.$refs.refMenu.clientHeight
        this.heightMenuPlaceholder = `${menuHeight}px`
      }, 100)
    },
    onCloseMenu() {
      this.isOpenMenu = false
      this.heightMenuPlaceholder = '0px'
    },

    openAuthorization(options) {
      this.isOpenAuthorization = true
      this.optionDialogAuthorization = options
    },
    handleClickAcuvue() {
      const isAcuvueUser = Boolean(Object.keys(this.$store?.state?.myacuvue?.profile)?.length > 0);
      if (isAcuvueUser) {
        this.$router.push({path: '/profile/my-acuvue'})
      } else {
        this.$emit('openDialogAuthorizationMyAcuvue')
      }
    }
  }
}
